import { api } from '@/scripts/api';

export const PayFundsService = {
    payFunds(accountId, fundRequestId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/pay-funds`;

            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });
    }
}
